export const useMetaPixel = () => {
  const { acceptedAnalytics } = useConsent()

  const {
    public: { metaPixelId },
  } = useRuntimeConfig()

  return useScriptMetaPixel({
    id: metaPixelId,
    scriptOptions: {
      trigger: acceptedAnalytics,
    },
  })
}
